import {AxiosResponse} from "axios";
import React from "react";
import {RouteComponentProps, withRouter} from "react-router-dom";
import {HttpError} from "../../../../common/components/shared/httpError/httpError";
import Loader from "../../../../common/components/shared/loader/loader";
import {HttpErrorModel} from "../../../../common/models/httpError";
import {RouteParamsModel} from "../../../../common/models/routeParams";
import {Api} from "../../../../helpers/api";
import i18n from "../../../../i18n/i18n";
import {OrderDetailModel} from "../../../models/order";
import OrderForm from "../orderForm/orderForm";
import {storesContext} from "../../../../common/stores/stores";
import {observer} from "mobx-react";
import {IOrderStore} from "../../../stores/orderStore";
import {OrderService} from "../../../services/orderService";

interface ModifyOrderState {
    orderData?: OrderDetailModel | null;
    response: AxiosResponse<HttpErrorModel[] | any> | undefined;
}

class ModifyOrder extends React.Component <RouteComponentProps, ModifyOrderState> {
    static contextType = storesContext;

    constructor(props: any) {
        super(props);

        this.state = {
            orderData: null,
            response: undefined,
        };
    }

    private get orderData() {
        return this.state.orderData;
    }

    async componentDidMount() {
        const params = this.props.match.params as RouteParamsModel;
        const response = await OrderService.getOrder(params.id);

        this.setState({response});

        if (Api.isSuccess(response)) {
            this.setState({
                orderData: response?.data || null
            });

            await this.setOrderStore();
        }
    }

    render() {
        return (
            <div className="modify-order modify-record">
                <div className="content">
                    <div className="header">
                        {i18n.t("transportation.order.modifyOrder.header")}
                    </div>
                    {this.renderContent()}
                </div>
            </div>
        );
    }

    private renderContent() {
        const params = this.props.match.params as RouteParamsModel;

        if (!Api.isSuccess(this.state.response)) {
            return <HttpError
                response={this.state.response}
                cause={i18n.t("transportation.order.modifyOrder.errors.retrievalErrorSuffix")}
            />;
        } else if (this.orderData) {
            return <OrderForm isUpdate={true} id={params.id}/>;
        } else {
            return (
                <Loader/>
            );
        }
    }

    private async setOrderStore() {
        const orderStore = this.context.orderStore as IOrderStore;
        orderStore.setOrder(this.orderData);
    }
}

export default withRouter(observer(ModifyOrder));